import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { TipuriAmenziService } from '../tipuri-amenzi.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-edit-tipuri-amenzi',
  templateUrl: './edit-tipuri-amenzi.component.html',
  styleUrls: ['./edit-tipuri-amenzi.component.scss'],
})
export class EditTipuriAmenziComponent implements OnInit {
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;

  helper = helper;

  token!: string;
  isLoading = false;

  form!: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditTipuriAmenziComponent>,
    private tipuriAmenziService: TipuriAmenziService,
    private notificationService: NotificationService
  ) {}

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = new FormGroup({
      id: new FormControl(this.data.id),
      numeTipTaxa: new FormControl(this.data.numeTipTaxa, Validators.required),
      observatii: new FormControl(this.data.observatii, Validators.required),
    });
  }

  submitForm() {
    this.isLoading = true;

    const data = {
      id: this.data.id,
      numeTipTaxa: this.form.get('numeTipTaxa')?.value,
      observatii: this.form.get('observatii')?.value,
    };
    this.tipuriAmenziService
      .updateAmenzi(data)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: () => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
